/**
 * Light carousel using native scrolling.
 *
 * @param carousel
 * @returns {Carousel}
 * @constructor
 */
function Carousel(carousel) {
  carousel.initialized = true;
  let item_size = '';
  let scroller = carousel.querySelector('.js-carousel-scrollbar');
  let prev = carousel.querySelector('.btn.js-prev');
  let next = carousel.querySelector('.btn.js-next');
  let controler = carousel.querySelector('.js-carousel-scrollbar-controls');

  // Fonction pour calculer et recalculer les paramètres quand le slider
  // change d'état et devient visible. Cette fonction est un callback d'un
  // observer définit plus bas.
  let recalculate = function (visible) {
    if (visible !== true) {
      controler.style.display = 'none';
      return false;
    }
    item_size = scroller.querySelector('div[data-transversal-type]:not(.d-none)').clientWidth;
    prev.setAttribute('disabled', '');
    next.removeAttribute('disabled');
    if(scroller.scrollWidth === scroller.offsetWidth){
      prev.style.display = next.style.display = controler.style.display = 'none';
    } else {
      prev.style.display = next.style.display = controler.style.display = 'block';
    }
    let eventListener = function(e) {
      if(e.target.scrollLeft <= 0){
        prev.setAttribute('disabled', '');
      } else {
        prev.removeAttribute('disabled');
      }
      if((e.target.offsetWidth + e.target.scrollLeft) >= e.target.scrollWidth){
        next.setAttribute('disabled', '');
      } else {
        next.removeAttribute('disabled');
      }
    };
    scroller.addEventListener('scroll', eventListener);
  };
  // L'observateur appelle recalculate() quand le carousel change de visibillité
  let intersection_observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      recalculate(entry.intersectionRatio > 0);
    });
  }, {
    root: document.documentElement,
  });
  intersection_observer.observe(carousel);

  // Callback sur modifications à l'intérieur du carousel (si on filtre par ex)
  let mutation_observer = new MutationObserver((mutationList, observer) => {
    recalculate(true);
  });
  mutation_observer.observe(scroller, { attributes: true, childList: true, subtree: true });

  // Gestion des boutons et de l'animation
  next.addEventListener('click', () => {
    scroller.scrollBy("+" + item_size, 0);
  });
  prev.addEventListener('click', () => {
    scroller.scrollBy("-" + item_size, 0);
  });
  return this;
}

document.querySelectorAll('.js-carousel-scrollbar-parent').forEach(function (carousel) {
  if(carousel.initialized === undefined){
    new Carousel(carousel);
  }
});
